export enum DragAndDropItemTypes {
   Media = 'media',
   Folder = 'folder',
   Mixed = 'mixed',
   Team = 'team',
   Collection = 'collection'
}
